module.exports = {
    // The application name, to be used when asking the configuration system for settings
    appName: 'MathsAZHost'
};
